<template>
  <div class="login">
    <v-card class="text-center pa-5" rounded>
      <v-container fluid>
        <v-row no-gutters align="stretch" justify="center" class="mb-3">
          <v-img
              src="@/assets/img/mini_logo_2.svg"
              max-width="100"
              class="justify-center"
          ></v-img>
        </v-row>
        <div class="text-h5 mb-10 font-weight-medium">Войти в кабинет</div>
        <template>
          <v-text-field
              label="Электронная почта"
              outlined
              type="text"
              v-model="email"
              v-on:keyup.enter="sign_in"
          ></v-text-field>
          <v-text-field
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              label="Пароль"
              outlined
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
              v-model="password"
              v-on:keyup.enter="sign_in"
          ></v-text-field>
          <v-btn class="mb-5"
                 large
                 color="primary"
                 block
                 :loading="loading"
                 @click="sign_in"
          >
            Продолжить
          </v-btn>
          <div class="text-center">
            <a href="http://newsupport.impeltech.ru/docs/reglament.pdf" target="_blank">
              Регламент системы предоставления услуг
            </a>
          </div>
        </template>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    showPass: false,
    loading: false,
    email: '',
    password: ''
  }),
  methods: {
    sign_in() {
      this.loading = true;
      this.$http.post(`${this.$serverApiLink}auth/login`, {
        'password': this.password,
        'email': this.email,
      }).then(
          response => {
            window.console.log(response.data.data);
            this.$store.commit('setUserLogin', response.data.data);
            this.loading = false;
            this.$router.push({ name: 'actual' });
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    }
  }
}
</script>